import { render, staticRenderFns } from "./ShowCompliance.vue?vue&type=template&id=c0402128&scoped=true"
import script from "./ShowCompliance.vue?vue&type=script&lang=js"
export * from "./ShowCompliance.vue?vue&type=script&lang=js"
import style0 from "./ShowCompliance.vue?vue&type=style&index=0&id=c0402128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0402128",
  null
  
)

export default component.exports